import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Global broken-image guard: any <img> that fails to load gets hidden so the
// browser's default "broken image" icon never appears anywhere on the site.
// Uses capture phase because the `error` event doesn't bubble from <img>.
// visibility:hidden keeps layout intact for hero backgrounds; the gradient
// behind them still shows through. Also sets data-broken so CSS can opt
// into stronger hiding (display:none) where layout doesn't matter.
if (typeof document !== "undefined") {
  document.addEventListener(
    "error",
    (e) => {
      const t = e.target;
      if (t && t.tagName === "IMG" && !t.dataset.broken) {
        t.dataset.broken = "1";
        t.style.visibility = "hidden";
      }
    },
    true
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
